/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_VectorsInputs */

const en_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

const ar_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#متجهات`)
};

const bn_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

const de_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

const es_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

const fr_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

const pt_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

const zh_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

const tr_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

const ru_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

const pl_svtag_vectors = /** @type {(inputs: Svtag_VectorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#VECTORS`)
};

/**
* | output |
* | --- |
* | "#VECTORS" |
*
* @param {Svtag_VectorsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_vectors = /** @type {((inputs?: Svtag_VectorsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_VectorsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_vectors(inputs)
	if (locale === "bn") return bn_svtag_vectors(inputs)
	if (locale === "de") return de_svtag_vectors(inputs)
	if (locale === "es") return es_svtag_vectors(inputs)
	if (locale === "fr") return fr_svtag_vectors(inputs)
	if (locale === "pt") return pt_svtag_vectors(inputs)
	if (locale === "zh") return zh_svtag_vectors(inputs)
	if (locale === "tr") return tr_svtag_vectors(inputs)
	if (locale === "ru") return ru_svtag_vectors(inputs)
	if (locale === "pl") return pl_svtag_vectors(inputs)
	return en_svtag_vectors(inputs)
});